import styles from "./FontSizeAdjustor.module.scss";
import classNames from "classnames";
import { useFontSizeAdjustor } from "../../hooks/fontSizeAdjustorHooks/useFontSizeAdjustor";
import { FONT_SIZES } from "../../utils/fontSizeSelection";

const FontSizeAdjustor = () => {
  const fontSizeAdjustor = useFontSizeAdjustor();

  return (
    <div className={styles.textSizeSlider}>
      <span className={classNames(styles.label, styles.small)}>T</span>
      <div className={styles.sliderContainer}>
        <div className={styles.sliderTrack}>
          <div className={styles.ticks}>
            {FONT_SIZES.map((size) => (
              <span key={size} className={styles.tick}></span>
            ))}
          </div>
          <input
            type="range"
            min="0"
            max={FONT_SIZES.length - 1}
            step="1"
            value={FONT_SIZES.indexOf(fontSizeAdjustor.selectedSize)}
            onChange={fontSizeAdjustor.setSelectedSize}
            className={styles.slider}
          />
        </div>
      </div>

      <span className={classNames(styles.label, styles.large)}>T</span>
    </div>
  );
};

export default FontSizeAdjustor;
